import { generateJsxKey } from '@utils/ast';
import { EmptyImageComponent } from './empty-image.js';
import { ImageComponent } from './image.js';
import { jsx } from 'react/jsx-runtime';

const printImageComponent = (node, context) => {
  return /*#__PURE__*/jsx(ImageComponent, {
    imageSrc: node.imageSrc,
    imageAlt: node.meta.alt,
    imageWidth: node.meta.imageWidth,
    imageHeight: node.meta.imageHeight,
    cssMaxWidth: undefined,
    enableScaling: node.options.enableScaling,
    enlargeOnClick: node.options.enlargeOnClick,
    isScrambled: node.pm2.isScrambled,
    displayCaption: node.options.displayCaption,
    caption: node.meta.caption,
    link: node.link,
    transcript: node.pm2.transcript,
    node: node
  }, generateJsxKey(context));
};
const printEmptyImageComponent = (node, context) => {
  return /*#__PURE__*/jsx(EmptyImageComponent, {}, generateJsxKey(context));
};
const imageComponentJsxPrinters = {
  "image-component": printImageComponent,
  "empty-image-component": printEmptyImageComponent
};

export { imageComponentJsxPrinters, printEmptyImageComponent, printImageComponent };
//# sourceMappingURL=printer.to-jsx.js.map
